import uuid from 'uuid/v4'
import isEmpty from 'lodash/isEmpty'

export default function useNestedAttributes(model: any, setModel: (model: any) => void, attributesKey: string) {
  const attributes: any = model[attributesKey] || {}
  const setAttributes = attrs => setModel({ ...model, [attributesKey]: attrs })
  const add = (data?: any) => {
    setAttributes({ ...attributes, [uuid()]: data || {} })
  }
  const remove = key => {
    const newAttributes = { ...attributes }
    if (newAttributes[key].id) {
      newAttributes[key]._destroy = true
    } else {
      delete newAttributes[key]
    }
    setAttributes(newAttributes)
  }
  const set = (key, data) => {
    setAttributes({ ...attributes, [key]: data })
  }

  const allAttributesAreDestroyed = () => Object.values(attributes).every((attr: any) => attr._destroy === true)
  const noVisibleAttributes = isEmpty(attributes) ? true : allAttributesAreDestroyed()

  return [attributes, noVisibleAttributes, add, remove, set]
}
